export default __webpack_public_path__ + "static/media/spt19.65861b15.jpeg";